export default __webpack_public_path__ + "static/media/8b57cc51267142f6a54a161e0c9636651600268026462.1fbefda2.webp";